import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import { formatImage } from '@ifeng-fe/public_method';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

let playEndIndex = 0;
const VideoBox = ({ content, videoBoxTitleImage }) => {
    const swiperRef = useRef();
    const videoRef = useRef();
    const [playConfig, setPlayConfig] = useState({
        playUrl: content[0].url,
        poster: content[0].postImage,
    });
    const [activeIndex, setActiveIndex] = useState(0);
    const [isPlay, setIsPlay] = useState(false);

    const changeVideoHandle = (data, index, action = 'click') => {
        setPlayConfig({
            playUrl: data?.url,
            poster: data?.postImage,
        });
        setActiveIndex(index);
        if (action === 'click') {
            playEndIndex = index;
        }
        setIsPlay(true);
        setTimeout(() => {
            videoRef.current.play();
        }, 300);
    };

    const playVideo = () => {
        videoRef.current.play();
        setIsPlay(true);
    };

    useEffect(() => {
        videoRef.current.addEventListener('ended', () => {
            if (playEndIndex + 1 < content.length) {
                changeVideoHandle(content?.[playEndIndex + 1], playEndIndex + 1, 'auto');
                playEndIndex++;
            }
        });
    }, []);

    useEffect(() => {
        videoRef.current.addEventListener('play', () => {
            setIsPlay(true);
        });
        videoRef.current.addEventListener('pause', () => {
            setIsPlay(false);
        });

        if (activeIndex === 0) {
            setTimeout(() => {
                videoRef.current.play().catch((err) => {
                    console.error('self_video', err);
                    videoRef.current.volume = 0;
                    videoRef.current.play();
                });
            }, 100);
        }
    }, []);

    return (
        <div className={styles.videoBox}>
            <Chip id="260869" title="视频专区标题图" groupName="中国力量" type="struct">
                <div className={styles.videoBoxTitle}>
                    <img className={styles.videoBoxTitle} src={videoBoxTitleImage} />
                </div>
            </Chip>
            <Chip id="260867" title="年度人物视频专区" groupName="中国力量" type="struct">
                <div>
                    <div className={styles.videoBoxPlayer}>
                        <video
                            className={styles.videoBoxTag}
                            controls
                            autoPlay
                            id="video"
                            x5-video-player-type="h5"
                            preload="metadata"
                            playsInline={true}
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            x5-video-orientation="portraint"
                            x5-video-player-fullscreen="true"
                            poster={playConfig.poster}
                            src={playConfig.playUrl}
                            ref={videoRef}
                            muted={false}
                        />
                        {!isPlay && <div className={styles.videoPlayIcon} onClick={playVideo} />}
                    </div>
                    <div className={styles.videoBoxSwiper}>
                        <Swiper
                            modules={[Navigation, Mousewheel, Keyboard]}
                            speed={300}
                            allowTouchMove={false}
                            slidesPerView={3}
                            spaceBetween={24}
                            loop
                            navigation={{ prevEl: `.${styles.prevBox}`, nextEl: `.${styles.nextBox}` }}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}>
                            {content.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div
                                            className={styles.videoBoxSwiperSlide}
                                            onClick={() => {
                                                changeVideoHandle(item, index, 'click');
                                            }}>
                                            <img className={styles.videoBoxSwiperPic} src={formatImage(item.postImage || item.backgroundImage, 320, 211)} />
                                            <div className={index === activeIndex ? styles.videoBoxSwiperActive : styles.videoBoxSwiperShadow} />
                                            <div className={styles.videoBoxSwiperText}>{item.title}</div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <div className={styles.prevBox}>
                            <img className={styles.prev} src="https://x0.ifengimg.com/ucms/2024_31/7A85075E8D75BF424840ADBDB8056A53D7C85A5C_size3_w29_h81.png" alt="" />
                        </div>
                        <div className={styles.nextBox}>
                            <img className={styles.next} src="https://x0.ifengimg.com/ucms/2024_31/1C300EA5DB96782B863E6B010CD69DEF21791EDF_size3_w29_h81.png" alt="" />
                        </div>
                    </div>
                </div>
            </Chip>
        </div>
    );
};

VideoBox.propTypes = {
    content: PropTypes.array,
    videoBoxTitleImage: PropTypes.string,
};

export default errorBoundary(VideoBox);
